import {IApiLeagueRestriction} from "../../typings/apiResponse";
import {LeagueRestriction} from "./LeagueRestriction";
import {ResidenceNationalityLeagueRestriction} from "./ResidenceNationalityLeagueRestriction";
import {GenderLeagueRestriction} from "./GenderLeagueRestriction";
import {TrustLevelLeagueRestriction} from "./TrustLevelLeagueRestriction";
import {AgeLeagueRestriction} from "./AgeLeagueRestriction";
import {CountryListLeagueRestriction} from "./CountryListLeagueRestriction";
import {GameAccountLeagueRestriction} from "./GameAccountLeagueRestriction";

export class LeagueRestrictionFactory {

    /**
     * Creates the correct restriction class by their type
     * @param restriction
     * @returns {LeagueRestriction}
     */
    static getRestrictionByType(restriction: IApiLeagueRestriction): LeagueRestriction {

        switch (restriction.type) {
            case 'residence_nationality':
                return new ResidenceNationalityLeagueRestriction(restriction);
            case 'gender':
                return new GenderLeagueRestriction(restriction);
            case 'trustlevel':
                return new TrustLevelLeagueRestriction(restriction);
            case 'minage':
                return new AgeLeagueRestriction(restriction);
            case 'inCountryList':
                return new CountryListLeagueRestriction(restriction);
            case 'gameaccount':
                return new GameAccountLeagueRestriction(restriction);
            default:
                return new LeagueRestriction(restriction);
        }
    }
}
